function run_gmaps(){

	jQuery('.pf-event-location-map').each(function(){
		var $maps_container = jQuery(this).find('.pf-event-location-map-inner')[0];

		var pf_event_locations = jQuery.parseJSON( jQuery(this).closest('.pf-event-details').find('input.pf_event_locations').val() );
		var pf_map = new google.maps.Map( $maps_container, { zoom: 16, center: new google.maps.LatLng(pf_event_locations[0].lat,pf_event_locations[0].lng ) } );
		var bounds = new google.maps.LatLngBounds();

		var marker_collection = [];
		var infowindow = null;
		jQuery.each(pf_event_locations, function( index, value ){
			var position = new google.maps.LatLng(value.lat, value.lng);
			var marker = new google.maps.Marker({
				position: position,
				map: pf_map,
				icon: { url: pf_gmaps.general_map_icon.sizes['pf-maps-72'] }				
			});
			marker_collection.push( marker );
			bounds.extend( position );
			
			marker.addListener( 'click', function(){
				if( infowindow ){
					infowindow.close();
				}
				infowindow = new google.maps.InfoWindow({'content': '<div class="pf-gmaps-info-window">' + value.address + '</div>' });
				infowindow.open( pf_map, marker );
			});
		});		

		jQuery($maps_container).data('pf_map', pf_map);		
		jQuery($maps_container).data('pf_map_markers', marker_collection);

		if( pf_event_locations.length > 1 ){
			pf_map.fitBounds( bounds );
		}

	});

	jQuery('body').on('click', '.pf-event-address', function (){
		if( typeof jQuery(this).data('map-id') === 'undefined' ){
			return false;
		}
		marker_id = jQuery(this).data('map-id');
		var map_container = jQuery(this).closest('.pf-event-details').find('.pf-event-location-map-inner');
		
		if( typeof jQuery(map_container).data('pf_map_markers') === 'undefined' ){
			return false;
		}
		
		var marker_collection = jQuery(map_container).data('pf_map_markers');		
		
		if( typeof marker_collection[marker_id] === 'undefined' ){
			return false;
		}

		google.maps.event.trigger( marker_collection[marker_id], 'click' );

	});

}